export const heroData = {
  name: "Pierre Iaccarino",
  title: "Développeur Symfony Freelance",
  tagline: "Transformer vos idées en projets web de qualité",
  location: "Bordeaux, France",
  cta: "Démarrons votre projet"
};

export const servicesData = [
  {
    id: 1,
    title: "Développement Symfony sur mesure",
    description: "Conception et développement d'applications web robustes et scalables avec un code propre, maintenable et respectant les meilleures pratiques.",
    gradient: "from-[#0066FF] to-[#7B61FF]"
  },
  {
    id: 2,
    title: "Refonte et modernisation d'applications",
    description: "Amélioration de code legacy et migration vers les versions récentes pour garantir performance et maintenabilité.",
    gradient: "from-[#7B61FF] to-[#FF4D8D]"
  },
  {
    id: 3,
    title: "Conseil technique et audit",
    description: "Expertise pour orienter vos choix techniques et optimiser votre architecture applicative.",
    gradient: "from-[#00D4FF] to-[#0066FF]"
  }
];

export const techStackData = [
  { name: "Symfony", icon: "code", featured: true },
  { name: "API Platform", icon: "api", featured: true },
  { name: "Doctrine", icon: "database" },
  { name: "MySQL", icon: "database" },
  { name: "PostgreSQL", icon: "database" },
  { name: "RabbitMQ", icon: "rabbit" },
  { name: "Docker", icon: "container" },
  { name: "CI/CD", icon: "workflow" }
];

export const aboutData = {
  bio: "Développeur Symfony passionné par la création d'applications web robustes et scalables. Je travaille en tant qu'auto-entrepreneur depuis juillet 2023, en parallèle de mon activité salariée. Mon approche privilégie la qualité du code, les bonnes pratiques et une collaboration étroite avec mes clients pour transformer leurs idées en solutions techniques performantes.",
  info: [
    { label: "Auto-entrepreneur depuis", value: "Juillet 2023" },
    { label: "Localisation", value: "Bordeaux, France" },
    { label: "Mode de travail", value: "100% Remote" },
    { label: "Disponibilité", value: "Actuellement disponible" },
    { label: "Idées concrétisées", value: "12 projets déployés" },
    { label: "TJM", value: "650€" }
  ],
  photo: "/api/placeholder/200/200"
};

export const contactData = {
  email: "freelance@pierreiaccarino.fr",
  linkedin: "https://www.linkedin.com/in/pierre-iaccarino-75a627153/"
};

export const submitContactForm = async (formData) => {
  const API_URL = process.env.REACT_APP_API_URL;

  if (!API_URL) {
    throw new Error('Une erreur est survenue. Veuillez réessayer plus tard.');
  }

  const response = await fetch(`${API_URL}/api/contact`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  });

  console.log(response);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Erreur lors de l\'envoi');
  }

  return response.json();
};